// external libs
import { Grid, Paper, Typography } from '@material-ui/core'

// utilities
import { convertDateToFormatEN, convertDateToFormatTH } from '../../../../../utilities/date'
import { getFileIconPath } from '../../../../../utilities/pathImg'

// hooks
import useTranslate from '../../../../../i18n/useTranslate'

// types
import type {
    ResultDocumentTopicLut as DocumentTopic,
    subtopicType as SubTopic,
} from '../../../../../services/lookup/types/responseLookupServiceTypes'
import type { DocumentTopicInfo as DocumentInfo } from '../../../../../services/web/types/responseWebServiceTypes'

interface PreviewUploadFileProps {
    no?: number | string
    documentTopic: DocumentTopic
    documentInfo?: DocumentInfo
}

const PreviewUploadFile = (props: PreviewUploadFileProps) => {
    const { no, documentTopic, documentInfo } = props

    const translate = useTranslate()
    const currentLanguage = translate.languageStore.currentLanguage
    const documentSubTopics = documentTopic.subtopic ?? []

    const getDocumentSubTopic = (subTopicId: number): SubTopic | undefined => {
        return documentSubTopics.find((e) => e.id === subTopicId)
    }

    const renderDisplayDate = (val: any) => {
        let display = ''
        if (val) {
            display =
                translate.languageStore.currentLanguage === translate.languageKey.th
                    ? 'ล่าสุดวันที่ ' + convertDateToFormatTH(val)
                    : 'Last updated ' + convertDateToFormatEN(val)
        }
        return display
    }

    return (
        <Grid container>
            <Grid container item md={10} sm={9} xs={12} justify={'flex-start'}>
                <Typography variant={'body2'}>{`${no ? `${no}.` : ''} ${documentTopic.code ?? ''} ${
                    documentTopic[`name_${currentLanguage}` as keyof DocumentTopic]
                }`}</Typography>
            </Grid>

            <Grid container item xs={12}>
                <Paper
                    variant="outlined"
                    style={{ width: '100%', padding: '10px 15px 15px 15px', margin: '5px', marginRight: '0px' }}
                >
                    {documentInfo?.fileInfo.map((fileInfo) => {
                        return (
                            <Grid key={fileInfo.fileToken} item xs={12}>
                                <Grid
                                    container
                                    style={{
                                        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                                        padding: '5px 0',
                                    }}
                                >
                                    <Grid container item xs={10} alignItems="center">
                                        <img
                                            src={process.env.PUBLIC_URL + getFileIconPath(fileInfo.filename)}
                                            alt="file icon"
                                            style={{ width: 24, height: 24, margin: 4, marginRight: 10 }}
                                        />

                                        <Typography variant={'body2'} style={{ wordBreak: 'break-word' }}>
                                            <a href={fileInfo.path} target="_blank" rel="noreferrer">
                                                {documentTopic.code}
                                                {fileInfo.filename}
                                            </a>
                                        </Typography>
                                        <Typography
                                            variant={'body2'}
                                            style={{ padding: '0 10px', wordBreak: 'break-word' }}
                                        >
                                            {renderDisplayDate(fileInfo.date)}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )
                    })}

                    {!documentInfo || documentInfo.fileInfo.length === 0 ? (
                        <Typography variant={'body2'} style={{ paddingTop: '5px', wordBreak: 'break-word' }}>
                            {translate.get('LABEL.NO_FILE_UPLOAD')}
                        </Typography>
                    ) : null}
                </Paper>
            </Grid>

            {!!documentInfo?.subtopic && Array.isArray(documentInfo.subtopic) && documentInfo.subtopic.length > 0 ? (
                <Grid item container xs={12} style={{ margin: 10 }} spacing={1}>
                    <Grid item container xs={11} justify={'flex-start'}>
                        <Typography variant={'body2'}>{translate.get('LABEL.PLEASE_FILL_IN_ADDRESS')}</Typography>
                    </Grid>
                    <Grid item container xs={1} justify={'flex-end'}>
                        <Typography variant={'body2'}>{translate.get('LABEL.PAGE')}</Typography>
                    </Grid>

                    {documentInfo.subtopic.map((e) => {
                        const documentSubTopic = getDocumentSubTopic(e.subtopicID)

                        if (!documentSubTopic) return null
                        return (
                            <>
                                <Grid container item xs={11} justify={'flex-start'}>
                                    <Typography variant={'body2'}>
                                        {documentSubTopic.no}
                                        {'. '}
                                        {translate.languageStore.currentLanguage === translate.languageKey.th
                                            ? documentSubTopic.name_th
                                            : documentSubTopic.name_en}
                                    </Typography>
                                </Grid>
                                <Grid item container xs={1} justify={'flex-end'}>
                                    <Typography variant={'body2'}>{e.page}</Typography>
                                </Grid>
                            </>
                        )
                    })}
                </Grid>
            ) : null}
        </Grid>
    )
}

export default PreviewUploadFile
